import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {faSpinnerThird} from '@fortawesome/pro-solid-svg-icons';

/**
 * Persistente Fortschritts-Karte für laufende Klassifizierungen.
 *
 * Zeigt „Klassifizierung läuft – N Dateien werden klassifiziert" an. Wird auf der
 * Dateien-Seite und der Dokumentenklassen-Seite wiederverwendet, damit Look und Text
 * identisch bleiben. Die Anzahl wird von außen (aus persistentem Backend-State) übergeben.
 */
@Component({
  selector: 'app-classification-progress-banner',
  standalone: true,
  imports: [FaIconComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div class="flex items-center gap-3 px-4 py-2.5 bg-blue-50 border-b border-blue-100">
      <fa-icon [icon]="faSpinnerThird" class="text-blue-500 animate-spin text-sm flex-shrink-0"></fa-icon>
      <span class="text-sm text-blue-700 font-medium">
        Klassifizierung läuft –
        {{ count }} {{ count === 1 ? 'Datei wird' : 'Dateien werden' }} klassifiziert
      </span>
    </div>
  `,
})
export class ClassificationProgressBannerComponent {
  @Input() count = 0;
  protected readonly faSpinnerThird = faSpinnerThird;
}
